/* istanbul ignore file */
export const WIDGET_PLAY_TYPE = 'play';
